import { Component, Input, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { StorageBucket } from '../../../../models'

@Component({
  selector: 'app-single-image-form-control',
  templateUrl: 'single-image.form-control.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SingleImageFormControlComponent), multi: true }
  ]
})

export class SingleImageFormControlComponent implements ControlValueAccessor {

  @Input() bucket: StorageBucket = null
  @Input() _value: string = null

  onChange: any = () => {}
  onTouched: any = () => {}

  get value() {
    return this._value
  }

  set value(val) {
    this._value = val
    this.onChange(val)
    this.onTouched()
  }

  registerOnChange(fn) {
    this.onChange = fn
  }

  registerOnTouched(fn) {
    this.onTouched = fn
  }

  writeValue(val) {
    if (val) { this._value = val; }
  }

  uploadChange(e) {
    this.onChange(e.file_key)
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/form-controls/single-image/single-image.form-control.ts